import React from "react";
import Layout from "../components/layout";
import Carousel from "../components/carousel";
import { Link } from "gatsby";
import Helmet from "react-helmet";
const IndexPage = () => (
  <Layout title="Next-Gen Cloud APM">
    <Helmet>
      <meta name="description" content="Next Gen APM, Infrastructure and Kubernetes Monitoring" />
      <meta name="keywords" content="apm, monitoring, java, kubernetes, containers, cloud, aws" />
    </Helmet>
    <div id="homepage">
      <section className="section topHero">
        <div className="container">
          <div className="columns is-vcentered">
            <div className="column">
              <h1 className="title">
                <span className="callout">Next Gen Monitoring</span> for
                <br />
                Cloud Infrastructure
              </h1>

              <Link className="button is-primary is-large has-text-weight-bold" to="/signup">
                Start Dripping
              </Link>
            </div>
            <div className="column">
              <img src="/img/home/cloud-home.png" alt="" />
            </div>
          </div>
        </div>
      </section>

      <section className="section testimonial-section">
        <div className="container">
          <Carousel />
        </div>
      </section>
      <section className="section benefits">
        <div className="container">
          <div className="columns is-vcentered is-variable is-6">
            <div className="column">
              <img src="/img/home/slice-and-dice.png" alt="" />
            </div>
            <div className="column">
              <div className="bTitle">Slice `n Dice Across Infrastructure</div>
              <div className="bDesc">See across your entire infrastructure. Slice n Dice through data interactively in real time.</div>
            </div>
          </div>

          <div className="columns is-vcentered  is-variable is-6">
            <div className="column">
              <div className="bTitle">LIVE Per-Second Metrics</div>
              <div className="bDesc">See it as it happens. Streaming feed of your key metrics.</div>
            </div>

            <div className="column">
              <img src="/img/home/live-per-second-metrics.png" alt="" />
            </div>
          </div>
        </div>
      </section>
    </div>
  </Layout>
);

export default IndexPage;
